import TicketSalesDetails from './TicketSalesDetails'

const TicketSalesTabs = (): JSX.Element => <TicketSalesDetails />

export default TicketSalesTabs
